import { ConversationState } from "@intelligems/ig-types";

export const initialWorkflowConversationState: ConversationState = {
  sessionId: "",
  workflowId: "",
  status: "waiting_for_input",
  messages: [],
  isStreaming: false,
  createdAt: 0,
  updatedAt: 0,
  nodeExecutionStatus: {},
};
